import { useState } from 'react';
import { Link } from 'react-router-dom';
import { getStoredConsent, setStoredConsent } from '../utils/consent';
import '../styles/components/CookieConsent.css';

export default function CookieConsent() {
  const [visible, setVisible] = useState(() => getStoredConsent() === null);

  if (!visible) return null;

  const choose = (value) => {
    setStoredConsent(value);
    setVisible(false);
  };

  return (
    <div className="cookie-consent" role="dialog" aria-label="Saglasnost za kolačiće">
      <p>
        Koristimo kolačiće za analitiku i prikaz relevantnih oglasa. Više informacija u{' '}
        <Link to="/politika-privatnosti">Politici privatnosti</Link>.
      </p>
      <div className="cookie-consent-actions">
        <button type="button" className="btn-decline" onClick={() => choose('denied')}>
          Odbij
        </button>
        <button type="button" className="btn-accept" onClick={() => choose('granted')}>
          Prihvati
        </button>
      </div>
    </div>
  );
}
